import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../store";
import moment from "moment";
import { getPaymentHistory } from "../../reducers/arrivalDetails_slice";
import useAxiosClient from "../useAxiosClient";
import {
  setDestPmtUpdated,
  setSrcPmtUpdated,
  updateTradeDetailsById,
} from "../../reducers/tradeDetail_byId_slice";
import { toast } from "react-toastify";
import {
  udpateAddDestPmt,
  udpateAddSrcPmt,
} from "../../reducers/paymentDetails_slice";
import Compressor from "compressorjs";
import { enableExcessPayment } from "../../helpers/getText";
import { setRefreshMovePmt } from "../../reducers/trade_details_Slice";

const usePaymentDetails = ({ type }: { type?: string }) => {
  const dispatch = useDispatch();

  const [billCreationStatus, setBillCreationStatus] = useState<{
    status: "" | "PENDING" | "COMPLETED" | "LOADING";
  }>({ status: "PENDING" });

  const {
    paymentUpdateStatus,
    paymentHistoryObj,
    tradeDetailsById,
    traderId,
    tradeId,
    adminId,
    isPaymentGateway,
    selectedPaymentType,
    arrivalpmtHistory,
    arrival,
    arrivalWight,
  } = useSelector((state: TRootState) => ({
    paymentUpdateStatus: state.arrivalDetails.paymentUpdateStatus,
    paymentHistoryObj: state.arrivalDetails.paymentHistoryObj,
    tradeDetailsById: state.tradeDetailsById.tradeDetailsbyId,
    traderId: state.tradeDetails.traderId,
    tradeId: state.tradeDetails.tradeId,
    adminId: state.auth.adminId,
    isPaymentGateway: state.arrivalDetails.isPaymentGateway,
    selectedPaymentType: state.paymentDetails.selectedPaymentType,
    arrivalpmtHistory: state.arrivalDetails.arrivalpmtHistory,
    arrival: state.arrivalDetails.arrivalDocs.arrival,
    arrivalWight: state.arrivalDetails.arrivalDocs.arrivalWight,
  }));

  const [otherDocuments, setOtherDocuments] = useState<
    Array<{ docType: "image" | "pdf"; url: string }>
  >([]);
  const [paymentDocuments, setPaymentDocuments] = useState<
    Array<{ docType: "image" | "pdf"; url: string }>
  >([]);

  const { handlePostCall } = useAxiosClient();

  const _caculatePaidAmount = () => {
    let amount = paymentHistoryObj?.amount;
    if (Number(paymentHistoryObj?.amtRcvd) > 0) {
      amount = Number(paymentHistoryObj?.amtRcvd);
    } else if (
      paymentUpdateStatus &&
      enableExcessPayment(paymentHistoryObj!.pmtType)
    ) {
      amount = paymentHistoryObj!.amount;
    }
    return Number(amount);
  };

  const _caculateTradeAmount = () => {
    let amount = paymentHistoryObj?.amount;
    if (
      Number(paymentHistoryObj?.amtRcvd) > 0 ||
      paymentHistoryObj?.pmtMode === "WALLET"
    ) {
      if (
        paymentUpdateStatus &&
        (paymentHistoryObj!.pmtType === "FINAL_PAYMENT" ||
          paymentHistoryObj!.pmtType === "FULL_PAYMENT")
      ) {
        amount =
          Number(tradeDetailsById?.finalPayable) +
          Number(tradeDetailsById?.destDelayCharges) -
          Number(tradeDetailsById?.inwardPmt) +
          Number(paymentHistoryObj?.amount);
      } else {
        amount = Number(paymentHistoryObj?.amount);
      }
    } else if (
      paymentUpdateStatus &&
      enableExcessPayment(paymentHistoryObj!.pmtType)
    ) {
      amount = _caculatePaidAmount() - _caculateWalletAmount();
    }
    return amount;
  };

  const _caculateWalletAmount = () => {
    let amount = 0;
    if (Number(paymentHistoryObj?.waAmount) > 0) {
      amount = Number(paymentHistoryObj?.waAmount);
    } else if (
      paymentUpdateStatus &&
      enableExcessPayment(paymentHistoryObj!.pmtType)
    ) {
      amount =
        Number(tradeDetailsById?.finalPayable) +
        Number(tradeDetailsById?.destDelayCharges) -
        Number(tradeDetailsById?.inwardPmt);
    }
    return Math.abs(amount);
  };

  const [recordPaymentData, setRecordPaymentData] = useState<{
    partyId: any;
    paymentDate: string;
    paidAmount: number | "";
    paymentType: string | "";
    paymentMode: string;
    comments: string;
    paymentTypeVal: string | "";
    requestAdv: number | "";
    pmtReceiptDate: string;
    desc: string;
    utr: string;
    paymentStatus: string;
    adjustedAmount: number | "";
    walletAmount: number | "";
    actualAmount: number | "";
    platformFee: number | "";
    delayedPmtCharges: number | "";
    finalReceivable: number | "";
  }>({
    partyId:
      selectedPaymentType === "OUTWARD"
        ? tradeDetailsById?.srcPartyId
        : tradeDetailsById?.destPartyId,
    paymentDate: paymentUpdateStatus
      ? moment(paymentHistoryObj?.date).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD"),
    paidAmount: _caculatePaidAmount(),
    paymentType: paymentUpdateStatus
      ? paymentHistoryObj?.pmtType
        ? paymentHistoryObj?.pmtType.toUpperCase() == "PARTIAL_PAYMENT"
          ? "PARTIAL_PAYMENT"
          : paymentHistoryObj?.pmtType.toUpperCase() || ""
        : paymentHistoryObj?.paymentType || ""
      : "",
    paymentMode: paymentUpdateStatus ? paymentHistoryObj?.pmtMode || "" : "",
    comments: paymentUpdateStatus ? paymentHistoryObj?.comments || "" : "",
    paymentTypeVal: paymentUpdateStatus
      ? paymentHistoryObj?.inOutWard || ""
      : type || "",
    requestAdv: paymentUpdateStatus
      ? paymentHistoryObj?.amount || ""
      : tradeDetailsById?.reqAdv?.requestAdv || "",
    pmtReceiptDate:
      paymentUpdateStatus && paymentHistoryObj?.pmtReceiptDate
        ? moment(paymentHistoryObj?.pmtReceiptDate).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD"),
    desc: paymentUpdateStatus ? paymentHistoryObj?.desc || "" : "",
    utr: paymentUpdateStatus ? paymentHistoryObj?.utr || "" : "",
    paymentStatus: paymentHistoryObj?.pmtStatus || "",
    adjustedAmount: _caculateTradeAmount() || "",
    walletAmount: _caculateWalletAmount(),
    actualAmount: paymentHistoryObj?.amount || "",
    platformFee: tradeDetailsById?.destPf || "",
    delayedPmtCharges: tradeDetailsById?.destDelayCharges || "",
    finalReceivable: tradeDetailsById?.finalPayable || "",
  });

  const onUploadReceiptImage = async (
    file: FileList | File[],
    docymentType:
      | "TAPAL_INVOICE"
      | "WEIGH_BRIDGE"
      | "OTHER"
      | "arival"
      | "patti"
      | "arrivalWight"
      | "payment" = "OTHER"
  ) => {
    const uploadPromises = Array.from(file).map(async (file) => {
      let fileType = "";
      if (file.type === "application/pdf") {
        fileType = "pdf";
      } else if (file.type?.includes("image/")) {
        fileType = "image";
      }
      let formdata = new FormData();
      formdata.append("traderId", traderId?.toString());
      if (fileType === "pdf") {
        formdata.append("file", file, file.name.replace(" ", "-"));
        let imageUploadResponse = await handlePostCall<string[]>({
          URL: "/mandi/files/trade-portal/imgs/upload",
          apiParams: formdata,
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        });
        let url = imageUploadResponse.data[0];
        if (docymentType === "payment") {
          setPaymentDocuments([
            { docType: "pdf", url: url },
            ...paymentDocuments,
          ]);
        } else {
          setOtherDocuments([{ docType: "pdf", url: url }, ...otherDocuments]);
        }
      } else {
        new Compressor(file, {
          quality: 0.8,
          success: async (compressedResult) => {
            formdata.append(
              "file",
              compressedResult,
              file.name.replace(" ", "-")
            );
            let imageUploadResponse = await handlePostCall<string[]>({
              URL: "/mandi/files/trade-portal/imgs/upload",
              apiParams: formdata,
              config: {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              },
            });
            let url = imageUploadResponse.data[0];
            if (docymentType === "payment") {
              setPaymentDocuments([
                { docType: "image", url: url },
                ...paymentDocuments,
              ]);
            } else {
              setOtherDocuments([
                { docType: "image", url: url },
                ...otherDocuments,
              ]);
            }
          },
        });
      }
    });
    await Promise.all(uploadPromises);
  };
  const onRemoveReceiptImage = (
    index: number,
    isExist: boolean = false,
    docymentType:
      | "invoice"
      | "receipt"
      | "OTHER"
      | "arival"
      | "patti"
      | "arrivalWight"
      | "payment" = "OTHER",
    id?: number
  ) => {
    if (isExist === true && tradeDetailsById !== null) {
      if (
        docymentType == "payment" &&
        paymentHistoryObj != null &&
        paymentUpdateStatus
      ) {
        let invoicesObj = { ...paymentHistoryObj };
        let invoices = [...paymentHistoryObj?.images];

        let i = invoices.findIndex((img) => img.id === id);

        if (i != -1) {
          invoices[i] = { ...invoices[i], status: 0 };
          invoicesObj.images = invoices;
          dispatch(
            getPaymentHistory({
              paymentHistoryObj: invoicesObj,
            })
          );
        }
      } else {
        let invoices = [...tradeDetailsById.otherDocumets];
        let i = invoices.findIndex((img) => img.id === index);
        invoices[i] = { ...invoices[i], status: 0 };
        dispatch(
          updateTradeDetailsById({
            tradeDetailsbyId: {
              ...tradeDetailsById,
              otherDocumets: invoices,
            },
          })
        );
      }
    } else {
      if (docymentType === "payment") {
        let newtapalInvoice = [...paymentDocuments];
        newtapalInvoice.splice(index, 1);
        setPaymentDocuments(newtapalInvoice);
      } else {
        let newtapalInvoice = [...otherDocuments];
        newtapalInvoice.splice(index, 1);
        setOtherDocuments(newtapalInvoice);
      }
    }
  };

  const submitRecordPayment = (
    closeRecordPaymentPanel: (paymentDone: boolean) => void
  ) => {
    setBillCreationStatus({ ...billCreationStatus, status: "LOADING" });
    // if (!recordPaymentData.partyId) {
    //   toast.error("Select Party");
    //   setBillCreationStatus({ ...billCreationStatus, status: "" });
    //   return;
    // }
    if (!recordPaymentData.paidAmount) {
      toast.error("Enter Paid/Received amount");
      setBillCreationStatus({ ...billCreationStatus, status: "" });
      return;
    }
    if (recordPaymentData.paymentType == "") {
      toast.error("Please select payment type");
      setBillCreationStatus({ ...billCreationStatus, status: "" });
      return;
    }
    if (
      recordPaymentData.paymentStatus == "" &&
      recordPaymentData?.paymentTypeVal == "OUTWARD"
    ) {
      toast.error("Please select payment status");
      setBillCreationStatus({ ...billCreationStatus, status: "" });
      return;
    }
    let imgs = [];
    if (paymentUpdateStatus) {
      if (paymentHistoryObj?.images) {
        for (let image of paymentHistoryObj.images) {
          if (image.status == 0) {
            imgs.push({
              ...image,
              addedBy: adminId,
              typeId: paymentUpdateStatus ? paymentHistoryObj?.id : 0,
              type: paymentUpdateStatus
                ? "PMT_" + paymentHistoryObj?.inOutWard
                : "PMT_" + recordPaymentData.paymentTypeVal,
            });
          }
        }
      }
    }
    if (otherDocuments.length > 0) {
      for (let file of otherDocuments) {
        imgs.push({
          id: 0,
          imgFrom: "TP_TRD",
          reqId: tradeId,
          status: 1,
          tradeId: tradeId,
          type: paymentUpdateStatus
            ? "PMT_" + paymentHistoryObj?.inOutWard
            : "PMT_" + recordPaymentData.paymentTypeVal,
          url: file.url,
          addedBy: adminId,
          typeId: paymentUpdateStatus ? paymentHistoryObj?.id : 0,
        });
      }
    }
    if (
      recordPaymentData?.paymentTypeVal == "OUTWARD" &&
      !paymentUpdateStatus &&
      isPaymentGateway
    ) {
      if (!tradeDetailsById?.payAcc?.rzpFa) {
        toast.error("Please activate a fund account");
        return;
      }
      handlePostCall({
        URL: "payments/payouts/traders/payouts",
        apiParams: {
          adminId: adminId,
          date: moment(recordPaymentData.paymentDate).format("YYYY-MM-DD"),
          amount: recordPaymentData?.paidAmount,
          currency: "INR",
          fund_account_id: tradeDetailsById?.payAcc?.rzpFa,
          mode: recordPaymentData.paymentMode,
          purpose: recordPaymentData.paymentType,
          tradeId: tradeId,
          traderId: recordPaymentData.partyId,
          notes: {
            notes_key_1:
              tradeDetailsById?.payAcc?.note1 ?? recordPaymentData?.comments,
            notes_key_2:
              tradeDetailsById?.payAcc?.note2 ?? recordPaymentData?.comments,
          },
          comments: recordPaymentData.comments,
        },
      })
        .then(({ data }) => {
          toast.success("updated successfully");
          setRecordPaymentData({
            ...recordPaymentData,
            partyId: "",
            paymentDate: moment().format("YYYY-MM-DD"),
            paidAmount: "",
            paymentType: "",
            paymentMode: "",
          });
          setOtherDocuments([]);
          closeRecordPaymentPanel(true);
        })
        .catch(() => {
          setBillCreationStatus({ ...billCreationStatus, status: "" });
        });
    } else {
      if (
        recordPaymentData?.paymentTypeVal === "INWARD" &&
        enableExcessPayment(paymentHistoryObj?.pmtType) &&
        Number(recordPaymentData?.paidAmount) <
          Number(recordPaymentData?.adjustedAmount)
      ) {
        toast.error(
          "Trade payment value cannot be greater than amount received"
        );
        setBillCreationStatus({ ...billCreationStatus, status: "" });
        return;
      }

      if (
        recordPaymentData?.paymentTypeVal === "INWARD" &&
        recordPaymentData.paymentMode === ""
      ) {
        toast.error("Please Select Payment Mode");
        setBillCreationStatus({ ...billCreationStatus, status: "" });
        return;
      }

      if (
        recordPaymentData?.paymentTypeVal === "INWARD" &&
        recordPaymentData?.utr === "" &&
        recordPaymentData.paymentMode != "WALLET"
      ) {
        toast.error("Please enter UTR number");
        setBillCreationStatus({ ...billCreationStatus, status: "" });
        return;
      }
      if (
        recordPaymentData?.paymentTypeVal === "INWARD" &&
        enableExcessPayment(recordPaymentData?.paymentType) &&
        Number(recordPaymentData.paidAmount) <
          Number(recordPaymentData.adjustedAmount)
      ) {
        toast.error("Trade Amount cannot be more than the amount received");
        setBillCreationStatus({ ...billCreationStatus, status: "" });
        return;
      }
      if (
        recordPaymentData?.paymentTypeVal === "INWARD" &&
        enableExcessPayment(recordPaymentData?.paymentType) &&
        Number(recordPaymentData.adjustedAmount) == 0
      ) {
        toast.error("Please enter the trade amount");
        setBillCreationStatus({ ...billCreationStatus, status: "" });
        return;
      }
      let paymentStatus = "ACCEPTED";
      if (recordPaymentData?.paymentTypeVal == "OUTWARD") {
        paymentStatus = recordPaymentData.paymentStatus;
      }
      let amount = Number(recordPaymentData?.paidAmount);
      let walletAmount = 0;
      let amountReceived = 0;
      if (
        recordPaymentData?.paymentTypeVal == "INWARD" &&
        (recordPaymentData.paymentType == "FINAL_PAYMENT" ||
          recordPaymentData.paymentType == "FULL_PAYMENT")
      ) {
        amount = Number(recordPaymentData.adjustedAmount);
        walletAmount = Number(recordPaymentData.walletAmount);
        amountReceived = recordPaymentData.paidAmount;
      }

      handlePostCall({
        URL: "admin/trade-platform/trades/payments",
        apiParams: {
          action: paymentUpdateStatus ? "UPDATE" : "",
          adminId: adminId,
          amount: amount,
          date: moment(recordPaymentData.paymentDate).format("YYYY-MM-DD"),
          images: imgs,
          inOutWard: paymentUpdateStatus
            ? paymentHistoryObj?.inOutWard
            : recordPaymentData.paymentTypeVal
            ? arrivalpmtHistory
              ? ""
              : recordPaymentData.paymentTypeVal
            : "",
          pmtMode: recordPaymentData.paymentMode,
          pmtType: recordPaymentData.paymentType
            ? recordPaymentData.paymentType.toUpperCase()
            : recordPaymentData.paymentType,
          tradeId: tradeId,
          traderId: recordPaymentData.partyId,
          id: paymentUpdateStatus ? paymentHistoryObj?.id : 0,
          status: paymentUpdateStatus ? 2 : 1,
          comments: recordPaymentData.comments,
          reqAdv: {
            advApproved: adminId,
            advDisb:
              tradeDetailsById?.reqAdv?.advDisb != 0 &&
              recordPaymentData?.paymentType != "ADVANCE"
                ? tradeDetailsById?.reqAdv?.advDisb
                : recordPaymentData?.requestAdv,
            disbDate: moment(recordPaymentData.paymentDate).format(
              "YYYY-MM-DD"
            ),
            tradeId: tradeId,
          },
          pmtStatus: paymentStatus,
          pmtReceiptDate: moment(recordPaymentData?.pmtReceiptDate).format(
            "YYYY-MM-DD"
          ),
          utr: recordPaymentData?.utr,
          desc: recordPaymentData?.desc,
          waAmount: walletAmount,
          pf: recordPaymentData?.platformFee,
          delayCharges: recordPaymentData?.delayedPmtCharges,
          amtRcvd: amountReceived,
        },
      })
        .then(({ data, status }) => {
          toast.success("Payment updated successfully");
          dispatch(setRefreshMovePmt(true));
          setRecordPaymentData({
            ...recordPaymentData,
            partyId: "",
            paymentDate: moment().format("YYYY-MM-DD"),
            paidAmount: "",
            paymentType: "",
            paymentMode: "",
          });
          setOtherDocuments([]);
          closeRecordPaymentPanel(true);
        })
        .catch(() => {
          setBillCreationStatus({ ...billCreationStatus, status: "" });
        });
    }
  };

  const { addSrcPmtDetail, addDestPmtDetail } = useSelector(
    (state: TRootState) => ({
      addSrcPmtDetail: state.paymentDetails.addSrcPmtDetail,
      addDestPmtDetail: state.paymentDetails.addDestPmtDetail,
    })
  );

  const calculateTotalFromPercentage = (
    _percentage: number,
    total: number
  ): number => (_percentage / 100) * total;
  const calculatePercentagefromTotal = (part: number, total: number) => {
    return (part / total) * 100;
  };

  const addDays = (date: any, days: any) => {
    var dateVal = date ? new Date(date) : new Date();
    var result = "";
    dateVal.setDate(dateVal.getDate() + parseInt(days));
    result = moment(dateVal).format("DD-MMM-YYYY");
    return result;
  };

  const updateSrcPmtTermInput = (type: string, value: string) => {
    let pmtDetail = addSrcPmtDetail;
    if (type === "ADVLMT") {
      pmtDetail = {
        ...pmtDetail,
        advanceLimit: Number(value),
      };
    } else if (type === "SRCPMTTERMS") {
      pmtDetail = {
        ...pmtDetail,
        pmtTerm: value,
        dueDate: addDays(tradeDetailsById?.arlDate, value),
      };
    }
    dispatch(udpateAddSrcPmt({ srcPmt: pmtDetail }));
  };

  const updateDestPmtTermInput = (type: string, value: string) => {
    let pmtDetail = addDestPmtDetail;

    if (type === "DESTPMTTERM") {
      pmtDetail = {
        ...pmtDetail,
        pmtTerm: value,
        dueDate: addDays(tradeDetailsById?.arlDate, value),
      };
    } else if (type === "DELAYCHARGESPER") {
      let delayedChargesPer = value !== "" ? parseFloat(value) : "";
      let delayedChargesVal = parseFloat(
        calculateTotalFromPercentage(
          value !== "" ? parseFloat(value) : 0,
          Number(tradeDetailsById?.pattiAmt)
        ).toFixed(2)
      );
      pmtDetail = {
        ...pmtDetail,
        delayedChargesPer: Number(delayedChargesPer),
        delayedChargesVal: delayedChargesVal,
      };
    } else if (type === "DELAYCHARGESVAL") {
      let delayedChargesPer = parseFloat(
        calculatePercentagefromTotal(
          value !== "" ? Number(value) : 0,
          Number(tradeDetailsById?.pattiAmt)
        ).toFixed(2)
      );
      let delayedChargesVal = value !== "" ? parseFloat(value) : "";

      pmtDetail = {
        ...pmtDetail,
        delayedChargesVal: Number(delayedChargesVal),
        delayedChargesPer: delayedChargesPer,
      };
    }
    dispatch(udpateAddDestPmt({ destPmt: pmtDetail }));
  };

  const updateDestDelayCharges = () => {
    let postBody = {};

    postBody = {
      adminId: adminId,
      delayCharges: {
        destDelayCharges: addDestPmtDetail?.delayedChargesVal,
      },
      tradeId: tradeDetailsById?.tradeId,
    };

    handlePutCall({
      URL: "admin/trade-platform/trades/metadata",
      apiParams: postBody,
    })
      .then(({ data, status }) => {
        toast.success(status.message);
        setIsDestPaymentEdit(false);
        dispatch(setDestPmtUpdated(true));
        dispatch(setRefreshMovePmt(true));
      })
      .catch(() => {});
  };

  const onChangeSrcDate = (type: string, date: string) => {
    if (type === "ARRDATE") {
      dispatch(
        udpateAddSrcPmt({
          srcPmt: {
            ...addSrcPmtDetail,
            arlDate: date,
          },
        })
      );
    } else if (type === "DUEDATE") {
      dispatch(
        udpateAddSrcPmt({
          srcPmt: {
            ...addSrcPmtDetail,
            dueDate: date,
          },
        })
      );
    }
  };

  const onChangeDestDate = (type: string, date: string) => {
    if (type === "ARRDATE") {
      dispatch(
        udpateAddDestPmt({
          destPmt: {
            ...addDestPmtDetail,
            arlDate: date,
          },
        })
      );
    } else if (type === "DUEDATE") {
      dispatch(
        udpateAddDestPmt({
          destPmt: {
            ...addDestPmtDetail,
            dueDate: date,
          },
        })
      );
    }
  };

  const [isSrcPaymentEdit, setIsSrcPaymentEdit] = useState(false);
  const [isDestPaymentEdit, setIsDestPaymentEdit] = useState(false);

  const { handlePutCall } = useAxiosClient();

  const updateSrcPaymenTermsData = () => {
    let postBody = {};

    postBody = {
      adminId: adminId,
      pmtDtls: {
        tradeId: tradeDetailsById?.tradeId,
        dueDate: moment(addSrcPmtDetail?.dueDate).format("YYYY-MM-DD"),
        destTradeStatus: tradeDetailsById?.destTradeStatus,
        rcomments: tradeDetailsById?.paymentComments,
        pmtTerms: parseInt(addSrcPmtDetail?.pmtTerm!),
        type: "SOURCE",
        advDate: tradeDetailsById?.reqAdv?.advDate,
        advLimit: addSrcPmtDetail?.advanceLimit,
        status:
          tradeDetailsById?.reqAdv != null
            ? tradeDetailsById?.reqAdv?.status == 1
              ? 2
              : tradeDetailsById?.reqAdv?.status || ""
            : 1,
      },
      tradeId: tradeDetailsById?.tradeId,
      tradeMode: tradeDetailsById?.tradeMode,
    };

    handlePutCall({
      URL: "admin/trade-platform/trades/metadata",
      apiParams: postBody,
    })
      .then(({ data, status }) => {
        toast.success(status.message);
        setIsSrcPaymentEdit(false);
        dispatch(setSrcPmtUpdated(true));
        dispatch(setRefreshMovePmt(true));
      })
      .catch(() => {});
  };

  const updateDestPaymenTermsData = () => {
    let postBody = {};

    postBody = {
      adminId: adminId,
      pmtDtls: {
        delayedPmtCharges: addDestPmtDetail?.delayedChargesVal,
        tradeId: tradeDetailsById?.tradeId,
        dueDate: moment(addDestPmtDetail?.dueDate).format("YYYY-MM-DD"),
        destTradeStatus: tradeDetailsById?.destTradeStatus,
        comments: tradeDetailsById?.paymentComments,
        pmtTerms: parseInt(addDestPmtDetail?.pmtTerm!),
        type: "DEST",
        status:
          tradeDetailsById?.reqAdv != null
            ? tradeDetailsById?.reqAdv?.status == 1
              ? 2
              : tradeDetailsById?.reqAdv?.status || ""
            : 1,
      },
      tradeId: tradeDetailsById?.tradeId,
      tradeMode: tradeDetailsById?.tradeMode,
    };

    handlePutCall({
      URL: "admin/trade-platform/trades/metadata",
      apiParams: postBody,
    })
      .then(({ data, status }) => {
        toast.success(status.message);
        setIsSrcPaymentEdit(false);
        setIsDestPaymentEdit(false);
        dispatch(setSrcPmtUpdated(true));
        dispatch(setDestPmtUpdated(true));
        dispatch(setRefreshMovePmt(true));
      })
      .catch(() => {});
  };
  return {
    recordPaymentData,
    setRecordPaymentData,
    onRemoveReceiptImage,
    onUploadReceiptImage,
    otherDocuments,
    submitRecordPayment,
    billCreationStatus,
    updateDestPmtTermInput,
    updateSrcPmtTermInput,
    onChangeSrcDate,
    onChangeDestDate,
    isSrcPaymentEdit,
    setIsSrcPaymentEdit,
    isDestPaymentEdit,
    setIsDestPaymentEdit,
    updateSrcPaymenTermsData,
    updateDestPaymenTermsData,
    paymentDocuments,
    updateDestDelayCharges,
  };
};
export default usePaymentDetails;
